import { PostStandbyCancelRequest } from 'src/sdk_checkin';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib';
import { StandbyCancelResultModel } from './standby-cancel-result.state';

/** StateDetailsActions */
const ACTION_SET = '[StandbyCancelResult] set';
const ACTION_UPDATE = '[StandbyCancelResult] update';
const ACTION_RESET = '[StandbyCancelResult] reset';
const ACTION_FAIL = '[StandbyCancelResult] fail';
const ACTION_CANCEL_REQUEST = '[StandbyCancelResult] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[StandbyCancelResult] set from api';
const ACTION_UPDATE_FROM_API = '[StandbyCancelResult] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setStandbyCancelResult = createAction(ACTION_SET, props<WithRequestId<StandbyCancelResultModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateStandbyCancelResult = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<StandbyCancelResultModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetStandbyCancelResult = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelStandbyCancelResultRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failStandbyCancelResult = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setStandbyCancelResultFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<StandbyCancelResultModel>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateStandbyCancelResultFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<StandbyCancelResultModel>>()
);
